import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Context/AuthContext';
import useRequestHandler from './../useRequestHandler';

const useDeleteLocation = () => {

    const { t } = useTranslation();
    const { acquireTokenSilently, apiClient } = useContext(AuthContext);
    const { errorHandler, successHandler } = useRequestHandler();
    const [ locationDoesNotExist, setLocationDoesNotExist ] = useState(false);

    /** Delete location 
     * @param {integer} id - location id
    */
    const deleteLocation = async (id) => {
        try {

            const accessToken = await acquireTokenSilently();
            
            if (accessToken === "login_required") throw Error("login_required");

            const result = await apiClient.delete(accessToken, "locations", id);

            return successHandler(result, "useDeleteLocation", "delete", { header: t('success.delete'), message: t('success.locationDeletedSuccesfully') });

        } catch (error) {

            const status = error.status || null;
            const data = error.data || {};
            const errorCode = data.errorCode || 0;

            if (status === 400 && errorCode === -1) setLocationDoesNotExist(true);

            return errorHandler(error, "useDeleteLocation", "delete");

        }
    }

    return { locationDoesNotExist, setLocationDoesNotExist, deleteLocation };

}

export default useDeleteLocation;
